export default __webpack_public_path__ + "static/media/group-option-glasses-selected.34dc6a49.svg";